/*
 * Copyright (c) 2025 Frayo and HomeChef360. All Rights Reserved.
 *
 * CONFIDENTIAL & PROPRIETARY
 * This software and its source code are the confidential and proprietary
 * information of Frayo and HomeChef360. Unauthorized copying, modification,
 * distribution, disclosure, or use of this code, in whole or in part, via any
 * medium, is strictly prohibited without prior written consent.
 *
 * Violations will be subject to legal action in the State of Florida and may
 * also be pursued under applicable U.S. federal law.
 */

import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { ChefSettlementDetail } from "../core/_requests";
import { useFormattedUtils } from "../../../component/dateUtils";

const SettlementDetails: React.FC = () => {
  const { id } = useParams();
  const { formatDateUS } = useFormattedUtils();
  const [settlement, setSettlement] = useState<any>({});
  const [settlementNotFound, setSettlementNotFound] = useState<boolean>(false);

  useEffect(() => {
        ChefSettlementDetail(id)
      .then((res) => {
                setSettlement(res.data);
      })
      .catch(() => {
        setSettlementNotFound(true);
      });
  }, []);

  return (
    <section className="container-fluid">
      <div className="row">
        <section className="content-section">
          <section className="row main-content">
            <div className="col-12 mt-md-2 mt-0">
              <div className="tab-content">
                <div className="tab-pane fade show active">
                  <button
                    className="btn btn-primary d-flex align-items-center mb-2 px-2 py-1"
                    onClick={() => window.history.back()}
                  >
                    <i className="material-symbols-outlined me-1">reply</i>
                    Go Back
                  </button>
                  {settlementNotFound ? (
                    <div className="error-layout text-center p-4">
                      <h5 className="text-danger">
                        Settlement Details Not Found
                      </h5>
                      <p className="text-secondary">
                        We couldn't retrieve the settlement details at this
                        time. Please contact support for assistance.
                      </p>
                    </div>
                  ) : (
                    <>
                      <div className="order-snippet mb-3">
                        <div className="os-head">
                          <div>
                            <h5 className="mb-0 medium primary-color">
                              Settelement Details
                            </h5>
                          </div>
                          <div></div>
                        </div>
                        <div className="row">
                          {/* Left Column (Two Sections) */}
                          <div className="col-12 col-lg-6 col-xl-6 mb-3 d-flex flex-column">
                            <div className="row os-body mt-3 flex-fill">
                              <div className="col-12">
                                <div className="bg-blk">
                                  <div className="row mb-1">
                                    <p className="col-7 mid-gray mb-0">
                                      <small>SettlementId</small>
                                    </p>
                                    <h6 className="col-5 mid-gray medium mb-0 amount">
                                      {settlement?.settlementId}{" "}
                                    </h6>
                                  </div>
                                  <div className="row mb-1">
                                    <p className="col-7 mid-gray mb-0">
                                      <small>Amount ($)</small>
                                    </p>
 <h6 className="col-5 mid-gray medium mb-0 amount">
  $ {settlement?.amount
      ? Number(settlement.amount).toFixed(2)
      : "0.00"}
</h6>



                                  </div>
                                  <div className="row mb-1">
                                    <p className="col-7 mid-gray mb-0">
                                      <small>Date</small>
                                    </p>
                                    <h6 className="col-5 mid-gray medium mb-0 amount">
                                      {formatDateUS(settlement?.date)}
                                    </h6>
                                  </div>
                                </div>
                              </div>
                            </div>
                            {/* <div className="row os-body mt-3 flex-fill">
                              <div className="col-12">
                                <div className="bg-blk">
                                  <div className="row mb-1">
                                    <h6 className="col-7 mid-gray medium mb-0 amount">
                                      Settlement Details{" "}
                                    </h6>
                                    <p className="col-5 mid-gray mb-0"></p>
                                  </div>
                                  <div className="row mb-1">
                                    <p className="col-7 mid-gray mb-0">
                                      <small>Gross Amount ($)</small>
                                    </p>
                                    <h6 className="col-5 mid-gray medium mb-0 amount">
                                      $ {settlement?.GrandgrossSettlementamount}
                                    </h6>
                                  </div>
                                  <div className="row mb-1">
                                    <p className="col-7 mid-gray mb-0">
                                      <small>
                                        Deductions ($)
                                        <span className="text-danger">(-)</span>
                                      </small>
                                    </p>
                                    <h6 className="col-5 mid-gray medium mb-0 amount">
                                      $ {settlement?.Granddeductionsamount}
                                    </h6>
                                  </div>
                                  <div className="row mb-1">
                                    <p className="col-7 mid-gray mb-0">
                                      <small>Net Amount ($)</small>
                                    </p>
                                    <h6 className="col-5 mid-gray medium mb-0 amount">
                                      $ {settlement?.GrandnetAmount}
                                    </h6>
                                  </div>
                                </div>
                              </div>
                            </div> */}
                          </div>
                          {/* Right Column (Equal Height) */}
                          <div className="col-12 col-lg-6 col-xl-6 mb-3 d-flex flex-column">
                            <div className="row os-body mt-3 flex-fill">
                              <div className="col-12">
                                <div className="bg-blk h-100 p-4">
                                  <h5>Settlement Summary</h5>
                                  <p className="text-secondary mb-2">
                                    <small>Status: Processed</small>
                                  </p>
                                  <h6>
                                    Processed on {formatDateUS(settlement?.date)} (
                                    {settlement?.daysAgo} days ago)
                                  </h6>
                                  <p className="text-secondary mt-2">
                                    The settlement has been successfully
                                    processed. Please note that it may take 2-3
                                    hours for the funds to appear in your bank
                                    account. If the money is not deposited by
                                    then, please contact your bank and provide
                                    the UTR number:{" "}
                                    <strong>{settlement?.utrNumber}</strong>.
                                  </p>
                                  <h6 className="mt-3">
                                    Funds to be Deposited
                                  </h6>
                                  <p className="text-secondary mb-1">
                                    <strong>
                                      Net Amount: $ {settlement?.GrandnetAmount}
                                    </strong>
                                  </p>
                                  <p className="text-secondary">
                                    The funds should be deposited by{" "}
                                    <strong>{settlement?.depositTime}</strong>{" "}
                                    today.
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-12 mt-4 mb-4">
                        <div className="snippet-block">
                          <div className="head">
                            <h6 className="mb-0">Recent Settlements</h6>
                          </div>
                          {/* Check if wallet array is empty */}

                          {settlement?.chefwallets?.length === 0 ? (
                            <div className="snippet-content">
                              <div className="no-data">
                                <img
                                  className="img-fluid mb-3"
                                  src="/assets/images/no-data-img.svg"
                                  alt="No Data"
                                />
                                <p className="mb-0 mid-gray">
                                  <small>
                                     No Funds Settled Yet – Check Back Soon!
                                  </small>
                                </p>
                              </div>
                            </div>
                          ) : (
                            <div className="snippet-content">
                              <table className="table custom-table mb-0">
                                <thead>
                                  <tr>
                                    <th>S.No</th>
                                    <th>Date</th>
                                    <th>Wallet Type</th>
                                    <th>Gross Amount ($)</th>
                                    <th>Deductions ($)</th>
                                    <th>Net Amount ($)</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {/* Use slice to get only the first 5 elements of the settlementDetail array */}
                                  {settlement?.chefwallets?.map(
                                    (settlementDetail: any, index: any) => (
                                      <tr key={index}>
                                        <td>{index + 1}</td>
                                        <td>{formatDateUS(settlementDetail?.date)}</td>
                                        <td>
                                          {settlementDetail?.walletType == 1 &&
                                            `Order ( ${settlementDetail?.orderId} )`}
                                          {settlementDetail?.walletType == 2 &&
                                            "Bonus"}
                                          {settlementDetail?.walletType == 3 &&
                                            "Plan Refund"}
                                          {settlementDetail?.walletType == 4 &&
                                            "Debit Subscription"}
                                          {settlementDetail?.walletType == 5 &&
                                            "Subscription Bonus"}

                                          {![1, 2, 3, 4, 5].includes(
                                            settlementDetail?.walletType
                                          ) && "Unknown"}
                                        </td>
                                        <td>$ {settlementDetail?.grossAmount}</td>
                                        <td>$ {settlementDetail?.deductions}</td>
                                        <td>$ {settlementDetail?.netAmount}</td>
                                      </tr>
                                    )
                                  )}
                                </tbody>
                              </table>
                            </div>
                          )}
                        </div>
                      </div>{" "}
                    </>
                  )}
                </div>
              </div>
            </div>
          </section>
        </section>
      </div>
    </section>
  );
};

export default SettlementDetails;
